import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ee95545"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "c999" }
const _hoisted_3 = {
  key: 0,
  class: "tips"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "upload-content"
}
const _hoisted_6 = { class: "upload-progress" }

import request from '@/utils/request'
import { ref } from 'vue'
import { Modal, Form } from 'ant-design-vue'
import excel from '@/assets/uploadFile/excel.svg'
import { DcMessage } from '@dc-platform/dc-components'
import { useI18n } from 'vue-i18n'

const __default__ = {
  name: 'uploadFile'
}

type fileTypes = {
  url: string
  name: string
}
type FileListTypes = {
  name: string
  uid?: string
  status?: string
  url: string
  response?: string
  type?: string
}
type UploadFileTypes = {
  name: string
  uid: string
  status: string
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  action: {
    type: String, // 接口地址
    default: ''
  },
  uploadText: {
    type: String
  },
  disabled: {
    type: Boolean,
    default: false
  },
  templateUrl: {
    type: String,
    default: ''
  },
  accept: {
    type: String,
    default: '.excel,.xls,.xlsx'
  },
  fileSize: {
    type: Number,
    default: 2 // 2M
  }
},
  emits: ['success', 'uploadSuccess'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n()
const props = __props
const uploadFile = ref<UploadFileTypes>()
const formItemContext = Form.useInjectFormItemContext()
const progress = ref<number>(10)
const fileList = ref<FileListTypes[]>([{ type: 'tips', name: 'tips', url: 'tips' }])
const resultFileList = ref<fileTypes[]>([])
const emit = __emit
// const fileFormatter = (data: any) => {
//   const file: {
//     name: string
//     uid: string
//     status: string
//     url: string
//     response: string
//   } = {
//     name: data.name,
//     uid: data.id,
//     status: 'done' || data.status,
//     url: data.url,
//     response: '{"status": "success"}' // 服务端响应内容
//   }
//   return file
// }
const change = () => {
  const result = fileList.value?.map((item) => {
    return {
      url: item.url,
      name: item.name
    }
  })
  resultFileList.value = result
  formItemContext.onFieldChange()
}
const remove = (info: FileListTypes) => {
  fileList.value = fileList.value?.filter((i) => {
    return i.uid !== info.uid
  })
  change()
}
const isTest = (fileName: string) => {
  const reg = new RegExp(`.(${props.accept.replace(/[.\s]/g, '').replace(/,/g, '|')})$`)
  return reg.test(fileName)
}
const beforeUpload = (file: any) => {
  if (!isTest(file.name)) {
    DcMessage.warning(t('tips.templeDownForm', { fileType: props.accept }))
    return false
  }
  const isLt10M = file.size / 1024 / 1024 < 2
  if (!isLt10M) {
    DcMessage.warning(t('tips.importSize10', { fileSize: props.fileSize }))
    return false
  }
}
const exportTemple = () => {
  const eleLink = document.createElement('a')
  eleLink.download = window.API_URL + props.templateUrl
  eleLink.style.display = 'none'
  eleLink.href = window.API_URL + props.templateUrl
  document.body.appendChild(eleLink)
  eleLink.click()
  document.body.removeChild(eleLink)
}
const customRequest = (file: any) => {
  const formData = new FormData()
  formData.append('file', file.file)
  uploadFile.value = {
    uid: file.file.uid,
    name: file.file.name,
    status: 'upload'
  }
  request({
    url: props.action,
    data: formData,
    method: 'POST',
    headers: {
      'Content-type': 'multipart/form-data'
    },
    onUploadProgress({ total, loaded }) {
      progress.value = 0
      progress.value = Math.round((loaded / (total * 2)) * 100)
    }
  })
    .then((res: any) => {
      if (res && res.code === 200) {
        const { failSize, successSize, resultUrl } = res.data
        if (failSize) {
          Modal.confirm({
            title: t('tips.exportError'),
            content: t('tips.jPXmeP', {
              sussess: successSize,
              error: failSize
            }),
            okText: t('btn.download'),
            cancelText: t('btn.closure'),
            onOk() {
              const eleLink = document.createElement('a')
              eleLink.download = resultUrl
              eleLink.style.display = 'none'
              eleLink.href = resultUrl
              document.body.appendChild(eleLink)
              eleLink.click()
              document.body.removeChild(eleLink)
            }
          })
        }
        if (!failSize && successSize) {
          DcMessage.success(t('tips.importSuccess'))
        }
        // 空内容
        if (!failSize && !successSize) {
          DcMessage.error(t('tips.importEmpty'))
        }
        if (successSize) {
          emit('success')
        }
      }
    })
    .finally(() => {
      uploadFile.value = undefined
    })
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_upload_dragger = _resolveComponent("a-upload-dragger")!
  const _component_a_progress = _resolveComponent("a-progress")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_upload_dragger, {
      accept: __props.accept,
      "file-list": fileList.value,
      "custom-request": customRequest,
      "before-upload": beforeUpload,
      onRemove: remove
    }, {
      itemRender: _withCtx(({ file }) => [
        (file.type === 'tips')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("p", null, [
                _createTextVNode(" 1." + _toDisplayString(_unref(t)('tips.templeDown')) + " :", 1),
                _createVNode(_component_a_button, {
                  style: {"padding":"0"},
                  type: "link",
                  primary: "",
                  onClick: exportTemple
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('btn.importTemplate')), 1)
                  ]),
                  _: 1
                })
              ]),
              (__props.accept)
                ? (_openBlock(), _createElementBlock("p", _hoisted_4, "2." + _toDisplayString(_unref(t)('tips.templeDownForm', { fileType: __props.accept })), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("img", {
            class: "world-time-item__img",
            src: _unref(excel),
            style: {"height":"36px","width":"36px"}
          }, null, 8, _hoisted_1),
          _createElementVNode("p", null, _toDisplayString(_unref(t)('tips.5FMCF8')), 1),
          _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('tips.or')), 1),
          _createVNode(_component_a_button, { type: "primary" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.uploadText || _unref(t)('btn.selectFile')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["accept", "file-list"]),
    (uploadFile.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_a_progress, {
              percent: progress.value,
              "stroke-color": "#3FAC46",
              status: "active",
              "stroke-width": 30
            }, null, 8, ["percent"]),
            _createElementVNode("p", {
              class: "upload-progress-percent",
              style: _normalizeStyle({ left: progress.value + '%' })
            }, _toDisplayString(progress.value) + "%", 5)
          ]),
          _createElementVNode("p", null, _toDisplayString(uploadFile.value.name), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})